import React from 'react';
import { Grid } from '@material-ui/core';
import useStyles from '../useStyles';
import { recommendationOptions } from './SelectOptionsTypes';
import { ServiceTypes } from '../RequestForQuotationUpload';
import { requestEnumToString } from '@utils/enumToString';
import { CustomizedTypography } from '@components/Customized';
import { UseFormMethods } from 'react-hook-form';
import { CapaQuotationRecommendation } from '@generated/graphql';
import { clsx } from '@components/Provider';
import { UploadedDrawingFileType } from '@modules/request';

interface Props extends ServiceTypes {
  onChange: (...event: any[]) => void;
  onBlur: () => void;
  value: CapaQuotationRecommendation[];
  name: string;
  methods: UseFormMethods<UploadedDrawingFileType>;
}

const OptionRecommendationBox = ({
  serviceType,
  name,
  value,
  methods
}: Props) => {
  const classes = useStyles();
  const options = recommendationOptions(serviceType);
  const { setValue } = methods;

  const onClick = (option: CapaQuotationRecommendation) => {
    const isExist = value.includes(option);
    const hasEtc = value.includes(CapaQuotationRecommendation.Etc);
    const hasDecideAfterConsulting = value.includes(
      CapaQuotationRecommendation.DecideAfterConsulting
    );

    if (value.length === 1 && isExist) {
      return setValue(name, []);
    }

    if (value.length === 2 && isExist) {
      return setValue(name, [...value.filter((v) => v !== option)]);
    }

    if (value.length === 1 && hasEtc) {
      return;
    }

    if (value.length === 1 && hasDecideAfterConsulting) {
      return;
    }

    if (option === CapaQuotationRecommendation.Etc) {
      return setValue(name, [CapaQuotationRecommendation.Etc]);
    }

    if (option === CapaQuotationRecommendation.DecideAfterConsulting) {
      return setValue(name, [
        CapaQuotationRecommendation.DecideAfterConsulting
      ]);
    }

    if (value.length === 2) {
      return;
    }

    return setValue(name, [...value, option]);
  };

  return (
    <Grid container className={classes['rfq-option-recommendation-box']}>
      {options.map((option, index) => (
        <Grid
          item
          component="div"
          key={index}
          className={clsx('recommend-chip', {
            'active': value.includes(option),
            'disabled':
              (option !== CapaQuotationRecommendation.DecideAfterConsulting &&
                value.includes(
                  CapaQuotationRecommendation.DecideAfterConsulting
                )) ||
              (option !== CapaQuotationRecommendation.Etc &&
                value.includes(CapaQuotationRecommendation.Etc))
          })}
          onClick={() => {
            onClick(option);
          }}
        >
          <CustomizedTypography
            variant="caption"
            color={value.includes(option) ? 'secondary' : 'textSecondary'}
            fontWeight="500"
          >
            {requestEnumToString(option)}
          </CustomizedTypography>
        </Grid>
      ))}
    </Grid>
  );
};

export default OptionRecommendationBox;
